import { render, staticRenderFns } from "./documentEdit.vue?vue&type=template&id=22d2a172&"
import script from "./documentEdit.vue?vue&type=script&lang=js&"
export * from "./documentEdit.vue?vue&type=script&lang=js&"
import style0 from "./documentEdit.vue?vue&type=style&index=0&id=22d2a172&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports